import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './styles/variables.css';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import News from './pages/News/News';
import Deals from './pages/Deals/Deals';
import Shops from './pages/Shops/Shops';
import Sidebar from './components/Sidebar/Sidebar';
import Feedback from './pages/Feedback/Feedback';
import SubscriberStats from './pages/SubscriberStats/SubscriberStats';
import Statistics from './pages/Statistics/Statistics';
import Loyalty from './pages/Loyalty/Loyalty';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/*"
          element={
            <div className="App">
              <Sidebar />
              <div className="content-with-sidebar">
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/news" element={<News />} />
                  <Route path="/deals" element={<Deals />} />
                  <Route path="/loyalty" element={<Loyalty />} />
                  <Route path="/shops" element={<Shops />} />
                  <Route path="/feedback" element={<Feedback />} />
                  <Route path="/subscribers" element={<SubscriberStats />} />
                  <Route path="/statistics" element={<Statistics />} />
                </Routes>
              </div>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App; 